import 'devextreme/integration/jquery';
import { locale, loadMessages } from 'devextreme/localization';
import ruMessages from 'devextreme/localization/messages/ru.json';
import Popup from 'devextreme/ui/popup';

export function dxSetup() {
    Popup.defaultOptions({ device: () => true, options: { animation: null } });
    loadMessages(ruMessages);
    locale('ru');
}
